export const splitDateCollab = (value = '') => {
    const trimmed = value.trim();
    const match = trimmed.match(/^(\d{4}-\d{2}-\d{2})(.*)$/);
    if (match) {
        return {
            date: match[1],
            collab: match[2].trim(),
        };
    }
    return {
        date: '',
        collab: trimmed,
    };
};
